import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex","flex-direction":"column-reverse"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]

import { ImMessage } from '@/app.context/workspace/tickets/_spec/Ticket.Im.Rmodel'
import { computed, onMounted, onUpdated, ref, watch } from 'vue';
import Editor from '@/components/tech/TextEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketIm',
  props: {
    messages: {},
    height: {}
  },
  emits: ['message', 'files'],
  setup(__props: any, { expose: __expose, emit: __emit }) {



__expose(
    {
        //data: function () { return { impersonal: data.impersonal, persons: data.persons, workable: data.workable } },
        reset: function () { DevScroll() },
        focus: function () { editor.value?.focus() },
    }
)


const emit = __emit

const editor = ref<InstanceType<typeof Editor> | null>(null)

const content = ref<HTMLElement | null>(null)

const props = __props;

const state: { scroll: boolean } = { scroll: true } //means 'keep autoscrolling'

function onFiles(files: File[]) {

    emit('files', files)

}

watch(() => props.height, () => {

    setup()
})


function setup(){

    if (content.value == null) return;

    if (props.height == 0) {
        content.value.style.maxHeight = "25vh"
        content.value.style.minHeight = "25vh"
    }
    else {
        const h = (props.height - 205).toString() + 'px'

        

        content.value.style.maxHeight = h
        content.value.style.minHeight = h
    }
}

function onScroll() {

    if (content.value) {

        const e = content.value;

        state.scroll = Math.abs(e.scrollTop - (e.scrollHeight - e.offsetHeight)) <= 1
    }
}

function onSubmit(value: string) {

    emit("message", value);

    if (props.messages != null) {

        const buffer = props.messages;

        //w/o this we got VUE error 'attempt to change prop'
        buffer.push(new ImMessage('me', value))
    }

    if (editor.value) {

        editor.value.clear();
    }
}


onMounted(()=>{
    setup()
})

//autoscrolling 
onUpdated(() => {

    if (state.scroll) {

        const e = content.value;

        if (e) e.scrollTop = e.scrollHeight;
    }
})



function DevScroll() {

    if (content.value) {

        content.value.scrollTop = content.value.scrollHeight;
    }

    state.scroll = true
}


return (_ctx: any,_cache: any) => {
  const _component_dev_button = _resolveComponent("dev-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Editor, {
      onFiles: onFiles,
      class: "chat-control dev-box",
      "model-value": '',
      ref_key: "editor",
      ref: editor,
      onSubmit: onSubmit
    }, null, 512),
    _createElementVNode("div", null, [
      _createVNode(_component_dev_button, { onClick: DevScroll }, {
        default: _withCtx(() => [
          _createTextVNode("Scroll")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "chat-content",
      ref_key: "content",
      ref: content,
      onScroll: onScroll
    }, [
      (props.messages != null)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.messages, (m, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tech-flex",
              key: i
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, "@" + _toDisplayString(m.sender), 1)
              ]),
              (m.file != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("img", {
                      class: "chat-img",
                      src: m.file
                    }, null, 8, _hoisted_3)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    innerHTML: m.content
                  }, null, 8, _hoisted_4))
            ]))
          }), 128))
        : _createCommentVNode("", true)
    ], 544)
  ]))
}
}

})